import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faCopy, faCheck } from '@fortawesome/free-solid-svg-icons';
import CustomSlugInput from 'components/CustomSlugInput/CustomSlugInput';
import FeatureCardLayout from './FeatureCardLayout';
import './CustomUrlCard.css';

interface CustomUrlCardProps {
  isElite: boolean;
  customSlug?: string | null;
  customSlugSetAt?: string | null;
}

const CustomUrlCard: React.FC<CustomUrlCardProps> = ({
  isElite,
  customSlug,
  customSlugSetAt,
}) => {
  const [copied, setCopied] = useState(false);
  const displaySlug = isElite && customSlug ? customSlug : 'yourname';

  const handleCopy = () => {
    navigator.clipboard.writeText(`https://trademagic.gg/u/${customSlug}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const preview = (
    <div className="url-card-preview">
      <div className="url-card-browser-bar">
        <FontAwesomeIcon icon={faLock} className="url-card-lock-icon" />
        <span className="url-card-url">
          trademagic.gg/u/<span className="url-card-slug-highlight">{displaySlug}</span>
        </span>
      </div>
      <div className="url-card-old-url">
        <span className="url-card-strikethrough">trademagic.gg/u/usr_a8f3k2</span>
      </div>
    </div>
  );

  let cta: React.ReactNode;
  if (isElite) {
    if (customSlug) {
      cta = (
        <div className="url-card-elite-cta">
          <span className="url-card-current">
            trademagic.gg/u/{customSlug}
          </span>
          <button className="feature-card-btn feature-card-btn--outline" onClick={handleCopy}>
            <FontAwesomeIcon icon={copied ? faCheck : faCopy} style={{ marginRight: 6 }} />
            {copied ? 'Copied!' : 'Copy URL'}
          </button>
        </div>
      );
    } else {
      cta = (
        <CustomSlugInput
          currentSlug={customSlug}
          customSlugSetAt={customSlugSetAt}
          isEliteActive={true}
        />
      );
    }
  } else {
    cta = (
      <p className="feature-card-aspirational">
        Claim a short, memorable profile URL
      </p>
    );
  }

  return (
    <FeatureCardLayout
      title="Custom Profile URL"
      description="Claim a short, memorable URL for your profile. Share it on Discord, Reddit, or your LGS community."
      previewContent={preview}
      ctaContent={cta}
      className="url-card"
    />
  );
};

export default CustomUrlCard;
